import {
    ChangeDetectionStrategy,
    Component,
    Input,
    Renderer2,
    inject
} from "@angular/core";
import { CommandDto } from "../../services/cqs/models/command-dto";

@Component({
    selector: "rask-command-viewer",
    styleUrls: ["./command-viewer.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: "./command-viewer.component.html"
})
export class CommandViewerComponent {
    @Input() commands: CommandDto[];

    private readonly renderer = inject(Renderer2);

    objectToList(object: any) {
        const result = [];
        for (const key in object) {
            if (Object.hasOwn(object, key)) {
                const element = object[key];
                result.push({
                    title: key,
                    value: element
                });
            }
        }
        return result;
    }

    toggle(e: MouseEvent) {
        e.preventDefault();
        e.stopImmediatePropagation();
        const closedClass = "closed";
        const isClosed = (e.target as any).classList.contains(closedClass);
        if (isClosed) {
            this.renderer.removeClass(e.target, closedClass);
        } else {
            this.renderer.addClass(e.target, closedClass);
        }
    }
}
